<template>
  <div class="box">
    <nav class="nav">
      <ul class="nav_l">
        <li>
          <router-link to="/">
            <img src="@/assets/logo.png" alt="" />
          </router-link>
        </li>
      </ul>
      <ul class="nav_r">
        <li>
          <router-link
            to="/"
            :active-class="routeName === 'index' ? 'navAct' : ''"
          >
            首页
          </router-link>
        </li>
        <li>
          <router-link
            to="/product"
            :class="
              routeName === 'product' || routeName === 'productDetail'
                ? 'navAct'
                : ''
            "
          >
            产品系列
          </router-link>
          <ul class="font">
            <li>
              <router-link :to="{ path: '/product', query: { name: 0 } }">
                旗舰奢华按摩椅系列
              </router-link>
            </li>
            <li>
              <router-link :to="{ path: '/product', query: { name: 1 } }">
                时尚简约按摩椅系列
              </router-link>
            </li>
            <li>
              <router-link :to="{ path: '/product', query: { name: 2 } }">
                超值舒享按摩椅系列
              </router-link>
            </li>
            <li>
              <router-link :to="{ path: '/product', query: { name: 3 } }">
                8推全功能按摩椅系列
              </router-link>
            </li>
            <li>
              <router-link :to="{ path: '/product', query: { name: 4 } }">
                眼部按摩器系列
              </router-link>
            </li>
            <li>
              <router-link :to="{ path: '/product', query: { name: 5 } }">
                小件按摩器系列
              </router-link>
            </li>
          </ul>
        </li>
        <li>
          <router-link
            to="/active"
            :active-class="routeName === 'active' ? 'navAct' : ''"
            >品牌动态</router-link
          >
          <ul>
            <li>
              <router-link :to="{ path: '/active', query: { id: 1 } }">
                跨界合作
              </router-link>
            </li>
            <li>
              <router-link :to="{ path: '/active', query: { id: 2 } }">
                明星达人推荐
              </router-link>
            </li>
          </ul>
        </li>
        <li>
          <router-link
            to="/about"
            :active-class="routeName === 'about' ? 'navAct' : ''"
          >
            关于摩摩哒
          </router-link>
          <ul>
            <li>
              <router-link :to="{ path: '/about', query: { id: 1 } }">
                荣泰背书
              </router-link>
            </li>
            <li>
              <router-link :to="{ path: '/about', query: { id: 2 } }">
                品牌理念
              </router-link>
            </li>
            <li>
              <router-link :to="{ path: '/about', query: { id: 3 } }"
                >品牌历程</router-link
              >
            </li>
            <li>
              <router-link :to="{ path: '/about', query: { id: 4 } }"
                >资质荣誉</router-link
              >
            </li>
          </ul>
        </li>
        <li>
          <router-link
            to="/officialMall"
            :active-class="routeName === 'officialMall' ? 'navAct' : ''"
            >官方商城</router-link
          >
        </li>
        <li>
          <router-link
            to="/contact"
            :active-class="routeName === 'contact' ? 'navAct' : ''"
            >联系我们</router-link
          >
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
export default {
  data() {
    return {
      routeName: "",
    };
  },
  mounted() {
    this.routeName = this.$route.name;
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.nav {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 1);
  display: flex;
  flex-direction: row;
  align-items: center;
  > ul {
    height: 100%;
    display: flex;
    align-items: center;
    > li {
      display: inline-block;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      > a {
        color: #fff;
        text-align: center;
        font-size: 1.4rem;
      }
    }
  }
  .nav_l {
    width: 40%;
    padding: 0 4rem;
    li a img {
      width: 12rem;
      display: block;
    }
  }
  .nav_r {
    width: 70%;
    > li {
      width: 15%;
      text-align: center;
      position: relative;

      > ul {
        display: none;
      }
    }
    > li:hover {
      > a {
        color: #f5bf4a;
        border-bottom: 3px solid #f5bf4a;
        padding-bottom: 10px;
        margin-bottom: -13px;
      }
      > ul {
        display: block;
        position: absolute;
        top: 6rem;
        background: #fff;
        width: 12rem;
        border-radius: 5px;
        z-index: 99;
        li {
          // cursor: pointer;
          > a {
            display: block;
            color: #101010;
            height: 4rem;
            line-height: 4rem;
            font-size: 1rem;
          }
        }
      }
      li:hover {
        background-color: rgba(245, 191, 74, 0.5);
        border-radius: 5px;
      }
    }
  }
}
.navAct {
  color: #f5bf4a !important;
  border-bottom: 3px solid #f5bf4a;
  padding-bottom: 10px;
  margin-bottom: -13px;
}
</style>
